import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FomoService } from '../../../../libs/services/fomo.service';

@Component({
  selector: 'app-fomo-top-banner',
  templateUrl: './fomo-top-banner.component.html',
  styleUrl: './fomo-top-banner.component.css',
})
export class FomoTopBannerComponent implements OnInit, OnDestroy {
  private fomoService = inject(FomoService);

  count = this.fomoService.count;
  isAnimating = this.fomoService.isAnimating;

  ngOnInit() {
    this.fomoService.start();
  }

  ngOnDestroy() {
    this.fomoService.stop();
  }
}
